// Addresses dropdown ---------------------------------------------------------------------
// -------------------------------------------------------------------------------------------

$(document).on('click', '.reset_addresses', function () {
  $(this).closest('.dropdown-menu').find('select.form-select').val(null).trigger('change');

  $(this)
    .closest('.dropdown_addresses')
    .children('button.btn.dropdown-toggle')
    .children('span')
    .addClass('gray-light')
    .attr('title', 'Trên toàn quốc')
    .text('Trên toàn quốc');
});

$(document).on('click', '.apply_addresses', function () {
  $(this).closest('.dropdown').dropdown('hide');
});

$(document).on('hide.bs.dropdown', '.dropdown_addresses', function (event) {
  // Define address names
  const addressNames = [];

  // Get street name
  const streetId = $(this).find('.ninex-street_id-field option:selected').val();
  if (streetId) {
    const streetName = $(this).find('.ninex-street_id-field option:selected').text();
    addressNames.push(streetName.trim());
  }

  // Get ward name
  const wardId = $(this).find('.ninex-ward_id-field option:selected').val();
  if (wardId) {
    const wardName = $(this).find('.ninex-ward_id-field option:selected').text();
    addressNames.push(wardName.trim());
  }

  // Get district name
  const districtId = $(this).find('.ninex-district_id-field option:selected').val();
  if (districtId) {
    const districtName = $(this).find('.ninex-district_id-field option:selected').text();
    addressNames.push(districtName.trim());
  }

  // Get province name
  const provinceId = $(this).find('.ninex-province_id-field option:selected').val();
  if (provinceId) {
    const provinceName = $(this).find('.ninex-province_id-field option:selected').text();
    addressNames.push(provinceName.trim());
  }

  const addressText = addressNames.join(', ');

  if (addressText) {
    $(this)
      .closest('.dropdown_addresses')
      .children('button.btn.dropdown-toggle')
      .children('span')
      .removeClass('gray-light')
      .attr('title', addressText)
      .text(addressText);
  } else {
    $(this)
      .closest('.dropdown_addresses')
      .children('button.btn.dropdown-toggle')
      .children('span')
      .addClass('gray-light')
      .attr('title', 'Trên toàn quốc')
      .text('Trên toàn quốc');
  }
});

// More filters dropdown ---------------------------------------------------------------------
// -------------------------------------------------------------------------------------------

$(document).on('click', '.reset_more_filters', function () {
  $(this).closest('.dropdown-menu').find('select.form-select').val(null).trigger('change');

  $(this)
    .closest('.dropdown_more_filters')
    .children('button.btn.dropdown-toggle')
    .children('span')
    .addClass('gray-light')
    .attr('title', 'Lọc thêm')
    .text('Lọc thêm');
});

$(document).on('click', '.apply_more_filters', function () {
  $(this).closest('.dropdown').dropdown('hide');
});

$(document).on('hide.bs.dropdown', '.dropdown_more_filters', function (event) {
  // Define filter names
  const filterNames = [];

  // Get direction name
  const directionValue = $(this).find('select[name=house_direction] option:selected').val();
  if (directionValue) {
    const directionName = $(this).find('select[name=house_direction] option:selected').text();
    filterNames.push('Hướng nhà ' + directionName.trim());
  }

  // Get balcony name
  const balconyValue = $(this).find('select[name=balcony_direction] option:selected').val();
  if (balconyValue) {
    const balconyName = $(this).find('select[name=balcony_direction] option:selected').text();
    filterNames.push('Hướng ban công ' + balconyName.trim());
  }

  // Get bedroom name
  const bedroomValue = $(this).find('select[name=number_of_bedrooms] option:selected').val();
  if (bedroomValue) {
    const bedroomName = $(this).find('select[name=number_of_bedrooms] option:selected').text();
    filterNames.push(bedroomName.trim() + ' phòng ngủ');
  }

  // Get furniture name
  const furnitureValue = $(this).find('select[name=furniture] option:selected').val();
  if (furnitureValue) {
    const furnitureName = $(this).find('select[name=furniture] option:selected').text();
    filterNames.push('Nội thất ' + furnitureName.trim());
  }

  // Get legal name
  const legalValue = $(this).find('select[name=legal] option:selected').val();
  if (legalValue) {
    const legalName = $(this).find('select[name=legal] option:selected').text();
    filterNames.push('Pháp lý ' + legalName.trim());
  }

  const filterText = filterNames.join(', ');

  if (filterText) {
    $(this)
      .closest('.dropdown_more_filters')
      .children('button.btn.dropdown-toggle')
      .children('span')
      .removeClass('gray-light')
      .attr('title', filterText)
      .text(filterText);
  } else {
    $(this)
      .closest('.dropdown_more_filters')
      .children('button.btn.dropdown-toggle')
      .children('span')
      .addClass('gray-light')
      .attr('title', 'Lọc thêm')
      .text('Lọc thêm');
  }
});
